<template>
  <div class="min-h-screen bg-white">
    <Head :title="`Specialists - ${site_context_label}`" />

    <!-- Header -->
    <div class="bg-white shadow">
      <div class="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <h1 class="text-3xl font-bold tracking-tight text-gray-900">
          Our Specialists
        </h1>
        <p class="mt-2 text-gray-600">
          {{ site_context_label }}
        </p>
      </div>
    </div>

    <!-- Specialists Grid -->
    <div class="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
      <div v-if="specialists.length > 0" class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <Link
          v-for="specialist in specialists"
          :key="specialist.id"
          :href="$routes.specialist(specialist.slug)"
          class="group overflow-hidden rounded-lg bg-white shadow-md transition-all duration-200 hover:shadow-lg"
        >
          <div class="aspect-[4/3] overflow-hidden bg-gray-200">
            <img
              v-if="specialist.photo_url"
              :src="specialist.photo_url"
              :alt="specialist.full_name"
              class="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105"
            >
            <div
              v-else
              class="flex h-full w-full items-center justify-center bg-gradient-to-br from-gray-300 to-gray-400"
            >
              <svg class="h-20 w-20 text-gray-500" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
              </svg>
            </div>
          </div>
          <div class="p-4">
            <h3 class="text-lg font-semibold text-gray-900 group-hover:text-indigo-600">
              {{ specialist.full_name }}
            </h3>
            <p v-if="specialist.title" class="mt-1 text-sm text-gray-600">
              {{ specialist.title }}
            </p>
            <p v-if="specialist.description" class="mt-2 line-clamp-3 text-sm text-gray-500">
              {{ specialist.description }}
            </p>
          </div>
        </Link>
      </div>

      <!-- Empty State -->
      <div v-else class="py-12 text-center">
        <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
        <h3 class="mt-2 text-sm font-semibold text-gray-900">No specialists</h3>
        <p class="mt-1 text-sm text-gray-500">
          There are no specialists available at this time.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';

export default {
  components: {
    Head,
    Link,
  },
  layout: Layout,
  props: {
    specialists: {
      type: Array,
      default: () => [],
    },
    // eslint-disable-next-line vue/prop-name-casing
    site_context: {
      type: String,
      default: null,
    },
    // eslint-disable-next-line vue/prop-name-casing
    site_context_label: {
      type: String,
      default: '',
    },
  },
};
</script>
